<script setup lang="ts">
const configStore = useConfigStore();
const routes = reactive([
  { link: `/`},
  { link: `/projects`},
  { link: `/achievements`},
  { link: `/contact`},
])
</script>

<template>
  <div class="flex justify-between items-center text-white text-lg sm:text-xl font-bold ">
    <div class="flex justify-center text-2xl mt-1">
      <RouterLink to="/" class="hover:brightness-150 transition-all ease-in duration-200 align-middle">
        <img draggable="false" src="../../assets/logo2.svg" alt="logo_img" class="size-12 inline">
        <span class=" pl-2">Styls.dev</span>
      </RouterLink>
    </div>
    <div class="flex justify-center items-center gap-x-5 max-lg:hidden">
      <RouterLink v-for="(rout,id) in routes"  :key="id" :to="rout.link"  class="pt-1 hover:text-pink-300 transition-all ease-in duration-200  after:block after:h-0.5 hover:after:w-[100%] after:w-[0%] after:bg-pink-300 after:transition-all after:ease-in after:duration-200" active-class="text-pink-300 underline underline-offset-8 after:hidden" >
        {{ $t(`home.menu.title${id+1}`)}}
      </RouterLink>
    </div>
    <div @click="configStore.openMenu=!configStore.openMenu" class="max-lg:block hidden">
        <Icon v-if="configStore.openMenu" icon="line-md:menu-to-close-alt-transition" class="hover:text-pink-300 size-8"/>
        <Icon v-else icon="line-md:close-to-menu-alt-transition" class="hover:text-pink-300 size-8"/>
    </div>
  </div>
</template>
